import { ArrowRight, Phone } from './Icons.jsx';

export function TutorCard({ tutor, reason, compact = false }) {
  return (
    <div style={{
      display: 'flex', gap: 14, padding: compact ? '12px 14px' : '16px 18px',
      background: '#fff', border: '1px solid var(--border)', borderRadius: 14,
      boxShadow: 'var(--shadow-card)', alignItems: 'center'
    }}>
      <img src={tutor.image} alt={tutor.name} style={{ width: compact ? 44 : 52, height: compact ? 44 : 52, borderRadius: '50%', flexShrink: 0 }} />
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, flexWrap: 'wrap' }}>
          <strong style={{ fontSize: compact ? 14 : 15.5 }}>{tutor.name}</strong>
          <span style={{ fontSize: 11, fontWeight: 700, color: 'var(--accent)', textTransform: 'uppercase', letterSpacing: '0.06em' }}>{tutor.score}</span>
        </div>
        <p style={{ margin: '2px 0 0', fontSize: 12.5, color: 'var(--text-muted)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{tutor.bio}</p>
        {reason && <p style={{ margin: '6px 0 0', fontSize: 12.5, color: 'var(--brand-purple)', fontWeight: 600 }}>{reason}</p>}
        <div style={{ marginTop: 6, fontSize: 11.5, color: 'var(--text-muted)' }}>
          <Phone width="12" height="12" style={{ verticalAlign: 'middle', marginRight: 4 }} />Next free 15-min: <strong>{tutor.nextSlot}</strong>
        </div>
      </div>
      <a className="btn btn-primary" style={{ flexShrink: 0, fontSize: 13, padding: '8px 14px' }}>Book <ArrowRight width="14" height="14" /></a>
    </div>
  );
}

export function TutorNudge({ tutor, reason, kicker = 'Recommended for you' }) {
  return (
    <section style={{
      marginTop: 24, padding: '20px 22px',
      background: 'linear-gradient(135deg, var(--accent-soft), #fff)',
      border: '1px solid rgba(124, 62, 175, 0.2)', borderRadius: 16
    }}>
      <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--brand-purple)', textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: 10 }}>{kicker}</div>
      <TutorCard tutor={tutor} reason={reason} />
    </section>
  );
}
